
        import * as module0 from './controllers/mobile_menu_controller.js'
        const modules = {
            "./controllers/mobile_menu_controller.js": module0,
        };
        export default modules;
      